<!-- no es promo combo -->
<div *ngIf="!promocion.getregla2() && tipoPromocion !== 'Combo'" class="ofertacard">
  <div class="contenidoofert">
    <div class="imagepr image-container-watermark">
      <div class="fondoLogo">
        <div class="oferlogo">
          {{ promocion.getAbreviaturaPromocion() || promocion.getNombrePromocion() }}
        </div>
      </div>
      <img class="img-pr" [src]="promocion.getFotoImagen()||promocion.getFoto()" loading="lazy"
        [alt]="promocion.getNombrePromocion()">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
           [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
           [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
    </div>
    <div *ngIf="promocion.getArticulo1()" class="descriofer">
      <!-- Con Categoria, getArticulo1() es un artículo cualquiera entre
           muchos: mostrar su nombre/cantidad como si fuera "el" producto
           de la promo confunde, así que se muestra el nombre de la promo. -->
      <div class="descprod" *ngIf="!esPromoCategoriaSinArticuloUnico">
        {{ promocion.getArticulo1().getDescripCion() || '' }}
      </div>
      <div class="descprod" *ngIf="esPromoCategoriaSinArticuloUnico">
        {{ promocion.getNombrePromocion() }}
      </div>
      <div class="cantidadofer" *ngIf="!esPromoCategoriaSinArticuloUnico">
        X {{ promocion.getCantidad1() }} un
      </div>
      <div *ngIf='!ocultarPrecios'>
        <div [ngSwitch]="tipoPromocion" class="precie">
          <div *ngSwitchCase="'Porcentaje'">
            {{ promocion.getPorcentaje() }} % de descuento
            <!-- Con Categoria, getArticulo1() es un artículo cualquiera entre
                 muchos, no "el" producto de la promo: mostrar su precio
                 puntual confunde, así que sólo se muestra para promos de un
                 solo artículo. -->
            <ng-container *ngIf="!esPromoCategoriaSinArticuloUnico">
              <div class="precioOriginalTachado">
                {{ promocion.getArticulo1().getPrecio() * promocion.getCantidad1() | currency }}
              </div>
              <div>
                {{ promocion.aplicarPromocion(promocion.getArticulo1().getPrecio() * promocion.getCantidad1()) |
                currency}}
              </div>
            </ng-container>
          </div>
          <div *ngSwitchCase="'MontoPromo'">
            Todo por {{ promocion.getMontoPromocion() | currency }}
            <div class="precioOriginalTachado">
              {{ promocion.getArticulo1().getPrecio() * promocion.getCantidad1() | currency }}
            </div>
            <div>
              {{ promocion.aplicarPromocion(promocion.getArticulo1().getPrecio() * promocion.getCantidad1()) |
              currency}}
            </div>
          </div>
          <div *ngSwitchCase="'DiferenciaPromo'">
            Descuento de {{ promocion.getMontoPromocion() |currency }}
            <div class="precioOriginalTachado">
              {{ promocion.getArticulo1().getPrecio() * promocion.getCantidad1() | currency }}
            </div>
            <div>
              {{ promocion.aplicarPromocion(promocion.getArticulo1().getPrecio() * promocion.getCantidad1()) |
              currency}}
            </div>
          </div>
          <div *ngSwitchCase="'NxM'">
            <div class="precioOriginalTachado">
              {{ promocion.getArticulo1().getPrecio() * promocion.getCantidad1() | currency }}
            </div>
            <div>
              {{ promocion.aplicarPromocion(promocion.getArticulo1().getPrecio() * promocion.getCantidad1()) |
              currency}}
            </div>
          </div>
          <div *ngSwitchDefault>
            Promo
          </div>
        </div>
      </div>
      <div class="btnarena" *ngIf="!esPromoCategoriaSinArticuloUnico">
        <boton-sumador style="margin: auto;" [fraccion]="0" [unidadMedida]="''" (quantyEvent)="agregarACarrito($event)"
          [contador]="cantidadPromocion">
        </boton-sumador>
      </div>
    </div>
  </div>
</div>
<!-- es promo combo -->
<div *ngIf="promocion.getregla2()" class="ofertacard">
    <div class="contenidoofert">
      <div class="imagepr image-container-watermark">
        <div class="fondoLogo">
          <div class="oferlogo">
            {{ promocion.getAbreviaturaPromocion() || promocion.getNombrePromocion() }}
          </div>
        </div>
        <img class="img-pr" [src]="promocion.getFotoImagen()||promocion.getFoto()" loading="lazy"
          [alt]="promocion.getNombrePromocion()">
        <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
             [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
             [style.opacity]="genServ.getOpacidadMarcadeagua()">
        </div>
      </div>
      <div class="descriofer">
        <div class="descprod">
        </div>
        <div class="cantidadofer">
        </div>
        <div class="precie">
          {{ promocion.getMontoPromocion() | currency}} {{ promocion.getPorcentaje() | currency }}
        </div>
        <div class="btnarena">
          <!--         <boton-sumador [fraccion]="articulo.getFraccion()" [unidadMedida]="articulo.getUnidadMedida()"(quantyEvent)="sumaevent($event)" [contador]="articulo.getCantidad()">
        </boton-sumador> -->
        </div>
      </div>
    </div>
  </div>
  <!-- combo tipo M: varios articulos (items[]) + precio fijo (monto) -->
  <div *ngIf="tipoPromocion === 'Combo'" class="ofertacard">
    <div class="contenidoofert">
      <div class="imagepr image-container-watermark">
        <div class="fondoLogo">
          <div class="oferlogo">
            {{ promocion.getAbreviaturaPromocion() || promocion.getNombrePromocion() }}
          </div>
        </div>
        <img class="img-pr" [src]="promocion.getFotoImagen()||promocion.getFoto()" loading="lazy"
          [alt]="promocion.getNombrePromocion()">
        <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
             [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
             [style.opacity]="genServ.getOpacidadMarcadeagua()">
        </div>
      </div>
      <div class="descriofer">
        <div class="descprod" *ngFor="let articulo of promocion.getArticulosItems(); let i = index">
          {{ articulo.getDescripCion() }} x {{ promocion.getItemsData()[i]?.cantidad1 }}
        </div>
        <div *ngIf='!ocultarPrecios'>
          <div class="precie">
            <div class="precioOriginalTachado">
              {{ $any(promocion).getSumaArticulos() | currency }}
            </div>
            <div>
              {{ promocion.getPrecio() | currency }}
            </div>
          </div>
        </div>
        <div class="btnarena">
          <boton-sumador style="margin: auto;" [fraccion]="0" [unidadMedida]="''"
            (quantyEvent)="agregarComboACarrito($event)" [contador]="promocion.getCantidad()">
          </boton-sumador>
        </div>
      </div>
    </div>
  </div>
